export const VERIFY_ADDRESS_STATUS = {
  loading: 'loading',
  failed: 'failed',
  verified: 'verified',
  unverified: 'unverified',
};

export const DEFAULT_ITEM_WEIGHT = 10;
export const ORDER_TABLE_PAGE_SIZE = 5;
export const MAX_SINGLE_BOOKINGS_COUNT = 20;

export const JOB_TYPE = {
  PICK_UP: 0,
  DROP_OFF: 1,
};

export const FINANCIAL_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
};

export const KLANG_VALLEY = 'Klang Valley';

export const KLANG_VALLEY_CITIES = [
  'Subang Jaya',
  'Kuala Lumpur',
  'Klang',
  'Petaling Jaya',
  'Sepang',
  'Shah Alam',
  'Ampang Jaya',
  'Kajang',
];

export const METRO_MANILA = 'Metro Manila';

export const METRO_MANILA_CITIES = [
  'Caloocan',
  'Malabon',
  'Navotas',
  'Valenzuela',
  'Quezon',
  'Marikina',
  'Pasig',
  'Taguig',
  'Makati',
  'Manila',
  'Mandaluyong',
  'San Juan',
  'Pasay',
  'Parañaque',
  'Paranaque',
  'Las Piñas',
  'Las Pinas',
  'Muntinlupa',
];
